import { onMounted as t, onBeforeUnmount as i } from "vue";
import o from "./ghl-ui.es1218.js";
function a(r, n) {
  n && (t(() => {
    const {
      value: e
    } = r;
    e && o.registerHandler(e, n);
  }), i(() => {
    const {
      value: e
    } = r;
    e && o.unregisterHandler(e);
  }));
}
export {
  a as useOnResize
};
